module.exports = __webpack_public_path__ + "static/media/29EUNOG14.25d50588.jpg";